import { useQuery } from '@tanstack/react-query'
import { endOfDay, format } from 'date-fns'

import { useCartStore } from '@/stores/cart-store/cartStore'

import { getServices } from '../api/getServices'

type UseGetServicesParams = {
	adults: number
	children: number
	roomTypeCode: string
	ratePlanCode: string
	enabled: boolean
}

export const useServices = ({ enabled, ...params }: UseGetServicesParams) => {
	const location = useCartStore.use.location()
	const { startDate, nights } = useCartStore.use.travelPeriod()
	const promotion = useCartStore.use.promotion()

	const isEnabled = Boolean(enabled && location && startDate && nights)

	return useQuery({
		queryKey: ['GET_SERVICES', params, startDate, nights, location, promotion.code],
		queryFn: () =>
			getServices({
				...params,
				arrivalDate: format(endOfDay(startDate!), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
				nights,
				hotelCode: location!.hotelCode,
				promotionCode: promotion.code,
			}),
		enabled: isEnabled,
	})
}
